// extracted by mini-css-extract-plugin
export default {"container":"ExternalSignIn_container__oX4Gh","spinner":"ExternalSignIn_spinner__IZTiC","content":"ExternalSignIn_content__CrEEy"};